
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11.61","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"2.384","cy":"5.212","rx":"1.837","ry":"2.035","fill":"#757575"}}),_c('ellipse',{attrs:{"cx":"2.384","cy":"11.61","rx":"1.837","ry":"2.035","fill":"#757575"}}),_c('ellipse',{attrs:{"cx":"2.384","cy":"18.006","rx":"1.837","ry":"2.035","fill":"#757575"}}),_c('ellipse',{attrs:{"cx":"9.209","cy":"18.006","rx":"1.837","ry":"2.035","fill":"#757575"}}),_c('ellipse',{attrs:{"cx":"9.209","cy":"11.61","rx":"1.837","ry":"2.035","fill":"#757575"}}),_c('ellipse',{attrs:{"cx":"9.209","cy":"5.212","rx":"1.837","ry":"2.035","fill":"#757575"}})])
          )
        }
      }
    